export default __webpack_public_path__ + "static/media/harry_on.38ac11ec.png";